import axios from 'axios'

export default {
    //Listado de vendedores
    get: () => axios.get('suppliers'),
    getByManager: (manager_id) => axios.get('suppliers/by-manager/'+manager_id),
    store: (data) => axios.post('suppliers/store', data),
    update: (data) => axios.post('suppliers/update', data),
    upgrade: (data) => axios.post('suppliers/upgrade', data),
    delete: (id) => axios.post('suppliers/delete', id),
    import: (data) => axios.post('suppliers/import', data),

    generateLink: (data) => axios.post('suppliers/generate-link', data),
    getByChallenge: (challenge_id) => axios.get('challenges/'+challenge_id+'/suppliers'),

    // Puntos vendedores canjeables
    getRedeemablePoints: () => axios.get('suppliers/redeemable-points'),
    getRedeemablePointsHistory: (id) => axios.get('suppliers/redeemable-points-history/'+id),
    getExcelRedeemablePoints: () => axios.get('suppliers/redeemable-points-excel'),
    deleteRedeemablePoint: (id) => axios.post('suppliers/delete-redeemable-points', id),
    getPointTickets: (type) => axios.post('suppliers/point-tickets', {type: type}),
    getPointProducts: (type) => axios.post('suppliers/point-products', {type: type}),
    boughtAward: (data) => axios.post('suppliers/awards/bought', data),
    
    getActives: () => axios.get('suppliers/actives'),
    getExcelActives: () => axios.get('suppliers/actives-excel'),
    updatePoints: (data) => axios.post('suppliers/update-points', data),
    getAwardExchangesHistory: () => axios.get('suppliers/awards/exchanges-history'),
    confirmWallet: (data) => axios.post('suppliers/confirm-wallet', data),
}